<mft-wc-wrapper
	*ngIf="showNewHeader; else legacyHeader"
	[options]="headerItem"
	class="mft-wc-wrapper height-auto"
></mft-wc-wrapper>
<ng-template #legacyHeader>
	<app-header
		[section]="section"
		[sections]="sections"
		[restrictions]="restrictions"
		[organizations]="organizations"
	></app-header>
</ng-template>
<div class="d-flex flex-grow-1">
	<mft-wc-wrapper
		*ngIf="enableOptimizationHub; else legacySidebar"
		[options]="sidebarItem"
		class="mft-wc-wrapper"
	></mft-wc-wrapper>
	<ng-template #legacySidebar>
		<app-sidebar
			[section]="section"
			[sections]="sections"
			[restrictions]="restrictions"
			[isCollapsed]="isSidebarCollapsed"
			[enableOptimizationHub]="enableOptimizationHub"
			(onSizeChanged)="onSidebarSizeChanged($event)"
		></app-sidebar>
	</ng-template>
	<div class="content">
		<router-outlet></router-outlet>
	</div>
</div>
